import React from 'react'
import { Route, Switch, Redirect } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { useCookies } from 'react-cookie'
import './App.css'

import HistoryProvider from 'context/HistoryContext'

import Projectmenberlist from './pages/Projectmenberlist'
import Groupmenberlist from './pages/Groupmenberlist'
import CampaignMenberlist from './pages/CampaignMenberlist'
import Fitgroupmake from './components/grouppage/fitgroup/Fitgroupmake'
import FitgroupmakeChage from './components/grouppage/fitgroup/FitgroupmakeChage'
import MypageSettingNotice from './components/mypage/mypagesetDetail/MypageSettingNotice'
import MypageSettingAlarm from './components/mypage/mypagesetDetail/MypageSettingAlarm'
import MypagePitgroup from './pages/MypagePitgroup'
import MypageProfileChange from './pages/MypageProfileChange'
import {
  OnboardingInit,
  OnboardingStep1A,
  OnboardingStep1B,
  OnboardingStep2,
  OnboardingStep3,
} from './pages/Onboarding'

import WrapperComponent from 'layouts/common/WrapperComponent'
import EmptyLayout from 'layouts/common/EmptyLayout'
import FooterLayout from 'layouts/common/FooterLayout'
import CharmdenEventPage from 'pages/CharmdenEventPage/CharmdenEventPage'

export default function App() {
  const userInfo = useSelector((state) => {
    return state.userInfo
  })

  const [cookies] = useCookies()

  /**
   * INFO
   * - qa, dev 환경에서는 브라우저에서도 온보딩 볼 수 있음
   * - prod 환경에서는 웹뷰에서만 온보딩 볼 수 있음
   */
  const shouldOnboarding =
    (process.env.REACT_APP_ENV === 'qa' ||
      process.env.REACT_APP_ENV === 'dev' ||
      !!window.ReactNativeWebView) &&
    userInfo['isMobile'] &&
    !userInfo['isLogin'] &&
    !cookies['is_onboarding_completed'] &&
    !cookies['is_sol_installed']

  return (
    <HistoryProvider>
      <WrapperComponent>
        <Switch>
          <Route exact path="/mypage/setting/notification" component={FooterLayout} />
          <Route path="/mypage/setting/notice" component={MypageSettingNotice} />
          <Route path="/mypage/setting/alarm" component={MypageSettingAlarm} />
          <Route path="/mypage/group/:id" component={MypagePitgroup} />
          <Route path="/mypage/profile/change/:id" component={MypageProfileChange} />
          <Route path="/group/create" component={Fitgroupmake} />
          <Route path="/group/modify/:id" component={FitgroupmakeChage} />
          <Route path="/group/menber/list/:id" component={Groupmenberlist} />
          <Route path="/campaign/:id/members" component={CampaignMenberlist} />
          <Route path="/group/project/:id/members" component={Projectmenberlist} />

          <Route exact path="/feed" component={FooterLayout} />

          <Route exact path="/">
            {shouldOnboarding ? <Redirect to={'/onboarding'} /> : <FooterLayout />}
          </Route>
          <Route path="/social" component={EmptyLayout} />
          <Route exact path="/christmas" component={EmptyLayout} />

          <Route exact path="/company" component={FooterLayout} />
          <Route exact path="/campaign/community/post" component={EmptyLayout} />
          <Route exact path="/group/community/post" component={EmptyLayout} />
          <Route path="/campaign/:id" component={EmptyLayout} />

          <Route exact path="/campaign/member/list" component={EmptyLayout} />

          <Route exact path="/task/list" component={FooterLayout} />
          <Route exact path="/task/friend/:friend_no/list" component={FooterLayout} />
          <Route exact path="/task/date/:date/list" component={FooterLayout} />
          <Route exact path="/task/create" component={EmptyLayout} />
          <Route exact path="/task/date/:date/create" component={EmptyLayout} />
          <Route exact path="/task/:task_no/update" component={EmptyLayout} />
          <Route exact path="/task/:id" component={EmptyLayout} />

          <Route exact path="/routine/list" component={EmptyLayout} />
          <Route exact path="/routine/create" component={EmptyLayout} />
          <Route exact path="/routine/:routine_no/update" component={EmptyLayout} />

          <Route exact path="/friend" component={EmptyLayout} />

          <Route exact path="/matching" component={FooterLayout} />
          <Route exact path="/matching/survey" component={EmptyLayout} />
          <Route exact path="/matching/room/create" component={EmptyLayout} />
          <Route exact path="/matching/room/:room_no" component={EmptyLayout} />
          <Route exact path="/matching/room/:room_no/update" component={EmptyLayout} />

          <Route exact path="/mypage" component={FooterLayout} />
          <Route exact path="/mypage/terms_and_conditions" component={EmptyLayout} />
          <Route exact path="/mypage/private_policy" component={EmptyLayout} />
          <Route exact path="/mypage/business_info" component={EmptyLayout} />
          <Route exact path="/mypage/policy/list" component={EmptyLayout} />
          <Route exact path="/mypage/setting" component={FooterLayout} />
          <Route exact path="/mypage/projects/list" component={EmptyLayout} />
          <Route exact path="/mypage/point" component={EmptyLayout} />
          <Route exact path="/mypage/point/use" component={EmptyLayout} />
          <Route exact path="/mypage/point/history" component={EmptyLayout} />
          <Route exact path="/mypage/point/policy" component={EmptyLayout} />

          <Route exact path="/archive" component={FooterLayout} />

          <Route exact path="/calendar" component={EmptyLayout} />
          <Route exact path="/calendar/date/:date" component={EmptyLayout} />

          <Route exact path="/tutorial" component={EmptyLayout} />
          <Route exact path="/tutorial/matching" component={EmptyLayout} />

          <Route path="/group/:group_no" component={EmptyLayout} />
          <Route exact path="/group/project/:project_no/update" component={EmptyLayout} />
          <Route exact path="/group/:group_no/project/create" component={EmptyLayout} />

          <Route exact path="/signup/main" component={EmptyLayout} />
          <Route exact path="/signup" component={EmptyLayout} />
          <Route exact path="/signup/company" component={EmptyLayout} />
          <Route exact path="/login" component={EmptyLayout} />
          <Route exact path="/account/delete" component={EmptyLayout} />
          <Route exact path="/write/personal" component={EmptyLayout} />
          <Route exact path="/users/shinhan/sol" component={EmptyLayout} />

          <Route exact path="/password" component={EmptyLayout} />
          <Route exact path="/password/reset" component={EmptyLayout} />

          <Route exact path="/motishop" component={FooterLayout} />
          <Route exact path="/motishop/product/:prodNo" component={EmptyLayout} />
          <Route exact path="/motishop/product/:prodNo/info" component={EmptyLayout} />
          <Route exact path="/motishop/product/:prodNo/achievement" component={EmptyLayout} />
          <Route exact path="/motishop/order" component={EmptyLayout} />
          <Route exact path="/motishop/order/:orderNo/approve" component={EmptyLayout} />
          <Route exact path="/motishop/order/:orderNo/deny" component={EmptyLayout} />
          <Route exact path="/motishop/order/:orderNo/invoice" component={EmptyLayout} />
          <Route exact path="/motishop/order/:orderNo/detail" component={EmptyLayout} />
          <Route exact path="/motishop/payback" component={EmptyLayout} />
          <Route exact path="/motishop/tutorial" component={EmptyLayout} />

          <Route exact path="/motibell/:motibellNo" component={EmptyLayout} />
          <Route exact path="/motibell/:motibellNo/landing" component={EmptyLayout} />

          <Route exact path="/event/charmden" component={CharmdenEventPage} />

          <Route exact path="/test" component={EmptyLayout} />

          <Route exact path="/onboarding">
            {shouldOnboarding ? <OnboardingInit /> : <Redirect to={'/'} />}
          </Route>
          <Route exact path="/onboarding/step1-A">
            {shouldOnboarding ? <OnboardingStep1A /> : <Redirect to={'/'} />}
          </Route>
          <Route exact path="/onboarding/step1-B">
            {shouldOnboarding ? <OnboardingStep1B /> : <Redirect to={'/'} />}
          </Route>
          <Route exact path="/onboarding/step2">
            {shouldOnboarding ? <OnboardingStep2 /> : <Redirect to={'/'} />}
          </Route>
          <Route exact path="/onboarding/step3">
            {shouldOnboarding ? <OnboardingStep3 /> : <Redirect to={'/'} />}
          </Route>
        </Switch>
      </WrapperComponent>
    </HistoryProvider>
  )
}
